import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';
import {Form, Modal, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {InputField} from '../../../../common/components/form';
import {paths} from '../../../../common/dictionaries/urls';
import {EXEMPTION_MANAGEMENT_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import {toInteger} from '../../../../common/util/fieldsNormalization';

class ExemptionManagementForm extends Component {
  componentDidMount() {
    const {permissions, code} = this.props;
    if (
      !hasAccessPermission(
        permissions,
        resources.ExemptionPercentagesManagement,
        scopes.Edit
      ) ||
      !hasAccessPermission(
        permissions,
        resources.ExemptionPercentagesManagement,
        scopes.Create
      )
    ) {
      this.props.push(paths.AccessDenied);
    }
    if (code) {
      this.props.fetchExemptionManagementInfo(code);
    }
  }

  componentWillUnmount() {
    this.props.clearExemptionForm();
  }

  onSubmit = async(formValues) => {
    const {create, closeModal, code} = this.props;
    if (create) {
      await this.props.addExemptionManagement(formValues);
    } else {
      await this.props.updateExemptionManagement(code, formValues);
    }
    this.props.fetchExemptionManagementList();
    closeModal();
  };

  render() {
    const {
      handleSubmit,
      loading,
      submitting,
      closeModal,
      code,
      minValueFrom,
      minValueTo,
      setDisabilityValueFrom,
    } = this.props;
    return (
      <Form
        className="exemption-form"
        onSubmit={handleSubmit(this.onSubmit)}
        loading={submitting || loading}
      >
        <h4>RANGO PORCENTAJE DE EXONERACION</h4>
        <Form.Group inline>
          <label className="main">DESDE</label>
          <Field
            name="disabilityPercentajeFrom"
            type="number"
            component={InputField}
            maxLength={3}
            normalize={toInteger}
            onBlur={(e, value) => setDisabilityValueFrom('disabilityPercentajeFrom', value, code)}
            required
            validate={minValueFrom}
          />
        </Form.Group>
        <Form.Group inline>
          <label className="main">HASTA</label>
          <Field
            name="disabilityPercentajeTo"
            type="number"
            maxLength={3}
            component={InputField}
            normalize={toInteger}
            validate={minValueTo}
            onBlur={(e, value) => setDisabilityValueFrom('disabilityPercentajeTo', value, code)}
            required
          />
        </Form.Group>
        <h4>PORCENTAJE DE EXONERACIÓN</h4>
        <Form.Group inline>
          <label className="main">%</label>
          <Field
            name="exonerationPercentaje"
            component={InputField}
            normalize={toInteger}
            required
          />
        </Form.Group>
        <Modal.Actions>
          <Button onClick={closeModal}>CERRAR</Button>
          <Button positive type="submit" disabled={submitting}>
            {'GRABAR'}
          </Button>
        </Modal.Actions>
      </Form>
    );
  }
}

export {ExemptionManagementForm};

const form = reduxForm({
  'form': EXEMPTION_MANAGEMENT_FORM.name,
})(ExemptionManagementForm);

const mapStateToProps = (state, ownProps) => {
  return {
    'push': ownProps.history.push,
    'permissions': state.session.permissions,
    'loading': state.advisorManagementForm.loading,
    'minValueFrom': ownProps.create ? state.exemptionManagment.minValueFrom : null,
    'minValueTo': state.exemptionManagment.minValueTo,
    'disabilityPercentajeFrom':
      state.exemptionManagementForm.values.disabilityPercentajeFrom,
  };
};

const {
  fetchExemptionManagementList,
  fetchExemptionManagementInfo,
  updateExemptionManagement,
  addExemptionManagement,
  setDisabilityValueFrom,
  clearExemptionForm,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    fetchExemptionManagementList,
    fetchExemptionManagementInfo,
    updateExemptionManagement,
    addExemptionManagement,
    setDisabilityValueFrom,
    clearExemptionForm,
  })(form)
);
